import { storableError } from '../../util/errors';
import {
  fetchAmlSeller as requestFetchAmlSeller,
  createAmlOccasionalSeller as requestCreateAmlOccasionalSeller,
  createAmlRegularSeller as requestCreateAmlRegularSeller,
  updateAmlSeller as requestUpdateAmlSeller,
  acceptAmlTerms as requestAcceptAmlTerms,
  uploadAmlDocuments as requestUploadAmlDocuments,
  createAmlTransfer as requestCreateAmlTransfer,
  completeAmlDataLoading as requestCompleteAmlDataLoading,
} from '../../util/api';
import { fetchCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

export const FETCH_AML_SELLER_REQUEST = 'app/PayoutPage/FETCH_AML_SELLER_REQUEST';
export const FETCH_AML_SELLER_SUCCESS = 'app/PayoutPage/FETCH_AML_SELLER_SUCCESS';
export const FETCH_AML_SELLER_ERROR = 'app/PayoutPage/FETCH_AML_SELLER_ERROR';

export const CREATE_AML_OCCASIONAL_SELLER_REQUEST =
  'app/PayoutPage/CREATE_AML_OCCASIONAL_SELLER_REQUEST';
export const CREATE_AML_OCCASIONAL_SELLER_SUCCESS =
  'app/PayoutPage/CREATE_AML_OCCASIONAL_SELLER_SUCCESS';
export const CREATE_AML_OCCASIONAL_SELLER_ERROR =
  'app/PayoutPage/CREATE_AML_OCCASIONAL_SELLER_ERROR';

export const CREATE_AML_REGULAR_SELLER_REQUEST = 'app/PayoutPage/CREATE_AML_REGULAR_SELLER_REQUEST';
export const CREATE_AML_REGULAR_SELLER_SUCCESS = 'app/PayoutPage/CREATE_AML_REGULAR_SELLER_SUCCESS';
export const CREATE_AML_REGULAR_SELLER_ERROR = 'app/PayoutPage/CREATE_AML_REGULAR_SELLER_ERROR';

export const ACCEPT_AML_TERMS_REQUEST = 'app/PayoutPage/ACCEPT_AML_TERMS_REQUEST';
export const ACCEPT_AML_TERMS_SUCCESS = 'app/PayoutPage/ACCEPT_AML_TERMS_SUCCESS';
export const ACCEPT_AML_TERMS_ERROR = 'app/PayoutPage/ACCEPT_AML_TERMS_ERROR';

export const UPDATE_AML_SELLER_REQUEST = 'app/PayoutPage/UPDATE_AML_SELLER_REQUEST';
export const UPDATE_AML_SELLER_SUCCESS = 'app/PayoutPage/UPDATE_AML_SELLER_SUCCESS';
export const UPDATE_AML_SELLER_ERROR = 'app/PayoutPage/UPDATE_AML_SELLER_ERROR';

export const UPLOAD_AML_DOCUMENTS_REQUEST = 'app/PayoutPage/UPLOAD_AML_DOCUMENTS_REQUEST';
export const UPLOAD_AML_DOCUMENTS_SUCCESS = 'app/PayoutPage/UPLOAD_AML_DOCUMENTS_SUCCESS';
export const UPLOAD_AML_DOCUMENTS_ERROR = 'app/PayoutPage/UPLOAD_AML_DOCUMENTS_ERROR';

export const CREATE_AML_TRANSFER_REQUEST = 'app/PayoutPage/CREATE_AML_TRANSFER_REQUEST';
export const CREATE_AML_TRANSFER_SUCCESS = 'app/PayoutPage/CREATE_AML_TRANSFER_SUCCESS';
export const CREATE_AML_TRANSFER_ERROR = 'app/PayoutPage/CREATE_AML_TRANSFER_ERROR';

export const COMPLETE_AML_DATA_LOADING_REQUEST = 'app/PayoutPage/COMPLETE_AML_DATA_LOADING_REQUEST';
export const COMPLETE_AML_DATA_LOADING_SUCCESS = 'app/PayoutPage/COMPLETE_AML_DATA_LOADING_SUCCESS';
export const COMPLETE_AML_DATA_LOADING_ERROR = 'app/PayoutPage/COMPLETE_AML_DATA_LOADING_ERROR';

// ================ Reducer ================ //

const initialState = {
  amlSeller: null,
  fetchAmlSellerInProgress: false,
  fetchAmlSellerError: null,
  createAmlOccasionalSellerInProgress: false,
  createAmlOccasionalSellerError: null,
  createAmlRegularSellerInProgress: false,
  createAmlRegularSellerError: null,
  updateAmlSellerInProgress: false,
  updateAmlSellerError: null,
  uploadAmlDocumentsInProgress: false,
  uploadAmlDocumentsError: null,
  acceptAmlTermsInProgress: false,
  acceptAmlTermsError: null,
  createAmlTransferInProgress: false,
  createAmlTransferError: null,
  completeAmlDataLoadingInProgress: false,
  completeAmlDataLoadingError: null,
};

export default function payoutPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case FETCH_AML_SELLER_REQUEST:
      return {
        ...state,
        fetchAmlSellerInProgress: true,
        fetchAmlSellerError: null,
      };
    case FETCH_AML_SELLER_SUCCESS:
      return {
        ...state,
        fetchAmlSellerInProgress: false,
        amlSeller: payload,
      };
    case FETCH_AML_SELLER_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return {
        ...state,
        fetchAmlSellerInProgress: false,
        fetchAmlSellerError: payload,
      };

    case CREATE_AML_OCCASIONAL_SELLER_REQUEST:
      return {
        ...state,
        createAmlOccasionalSellerInProgress: true,
        createAmlOccasionalSellerError: null,
      };
    case CREATE_AML_OCCASIONAL_SELLER_SUCCESS:
      return {
        ...state,
        createAmlOccasionalSellerInProgress: false,
        amlSeller: payload,
      };
    case CREATE_AML_OCCASIONAL_SELLER_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return {
        ...state,
        createAmlOccasionalSellerInProgress: false,
        createAmlOccasionalSellerError: payload,
      };

    case CREATE_AML_REGULAR_SELLER_REQUEST:
      return {
        ...state,
        createAmlRegularSellerInProgress: true,
        createAmlRegularSellerError: null,
      };
    case CREATE_AML_REGULAR_SELLER_SUCCESS:
      return {
        ...state,
        createAmlRegularSellerInProgress: false,
        amlSeller: payload,
      };
    case CREATE_AML_REGULAR_SELLER_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return {
        ...state,
        createAmlRegularSellerInProgress: false,
        createAmlRegularSellerError: payload,
      };

    case ACCEPT_AML_TERMS_REQUEST:
      return {
        ...state,
        acceptAmlTermsInProgress: true,
        acceptAmlTermsError: null,
      };
    case ACCEPT_AML_TERMS_SUCCESS:
      return {
        ...state,
        acceptAmlTermsInProgress: false,
        amlSeller: payload,
      };
    case ACCEPT_AML_TERMS_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return {
        ...state,
        acceptAmlTermsInProgress: false,
        acceptAmlTermsError: payload,
      };

    case UPDATE_AML_SELLER_REQUEST:
      return {
        ...state,
        updateAmlSellerInProgress: true,
        updateAmlSellerError: null,
      };
    case UPDATE_AML_SELLER_SUCCESS:
      return {
        ...state,
        updateAmlSellerInProgress: false,
        amlSeller: payload,
      };
    case UPDATE_AML_SELLER_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return {
        ...state,
        updateAmlSellerInProgress: false,
        updateAmlSellerError: payload,
      };

    case UPLOAD_AML_DOCUMENTS_REQUEST:
      return {
        ...state,
        uploadAmlDocumentsInProgress: true,
        uploadAmlDocumentsError: null,
      };
    case UPLOAD_AML_DOCUMENTS_SUCCESS:
      return {
        ...state,
        uploadAmlDocumentsInProgress: false,
      };
    case UPLOAD_AML_DOCUMENTS_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return {
        ...state,
        uploadAmlDocumentsInProgress: false,
        uploadAmlDocumentsError: payload,
      };

    case CREATE_AML_TRANSFER_REQUEST:
      return {
        ...state,
        createAmlTransferInProgress: true,
        createAmlTransferError: null,
      };
    case CREATE_AML_TRANSFER_SUCCESS:
      return {
        ...state,
        createAmlTransferInProgress: false,
      };
    case CREATE_AML_TRANSFER_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return {
        ...state,
        createAmlTransferInProgress: false,
        createAmlTransferError: payload,
      };

    case COMPLETE_AML_DATA_LOADING_REQUEST:
      return {
        ...state,
        completeAmlDataLoadingInProgress: true,
        completeAmlDataLoadingError: null,
      };
    case COMPLETE_AML_DATA_LOADING_SUCCESS:
      return {
        ...state,
        completeAmlDataLoadingInProgress: false,
        amlSeller: payload,
      };
    case COMPLETE_AML_DATA_LOADING_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return {
        ...state,
        completeAmlDataLoadingInProgress: false,
        completeAmlDataLoadingError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchAmlSellerRequest = () => ({
  type: FETCH_AML_SELLER_REQUEST,
});

const fetchAmlSellerSuccess = amlSeller => ({
  type: FETCH_AML_SELLER_SUCCESS,
  payload: amlSeller,
});

const fetchAmlSellerError = e => ({
  type: FETCH_AML_SELLER_ERROR,
  error: true,
  payload: storableError(e),
});

const createAmlOccasionalSellerRequest = () => ({
  type: CREATE_AML_OCCASIONAL_SELLER_REQUEST,
});

const createAmlOccasionalSellerSuccess = amlSeller => ({
  type: CREATE_AML_OCCASIONAL_SELLER_SUCCESS,
  payload: amlSeller,
});

const createAmlOccasionalSellerError = e => ({
  type: CREATE_AML_OCCASIONAL_SELLER_ERROR,
  error: true,
  payload: storableError(e),
});

const createAmlRegularSellerRequest = () => ({
  type: CREATE_AML_REGULAR_SELLER_REQUEST,
});

const createAmlRegularSellerSuccess = amlSeller => ({
  type: CREATE_AML_REGULAR_SELLER_SUCCESS,
  payload: amlSeller,
});

const createAmlRegularSellerError = e => ({
  type: CREATE_AML_REGULAR_SELLER_ERROR,
  error: true,
  payload: storableError(e),
});

const acceptAmlTermsRequest = () => ({
  type: ACCEPT_AML_TERMS_REQUEST,
});

const acceptAmlTermsSuccess = amlSeller => ({
  type: ACCEPT_AML_TERMS_SUCCESS,
  payload: amlSeller,
});

const acceptAmlTermsError = e => ({
  type: ACCEPT_AML_TERMS_ERROR,
  error: true,
  payload: storableError(e),
});

const updateAmlSellerRequest = () => ({
  type: UPDATE_AML_SELLER_REQUEST,
});

const updateAmlSellerSuccess = amlSeller => ({
  type: UPDATE_AML_SELLER_SUCCESS,
  payload: amlSeller,
});

const updateAmlSellerError = e => ({
  type: UPDATE_AML_SELLER_ERROR,
  error: true,
  payload: storableError(e),
});

const uploadAmlDocumentsRequest = () => ({
  type: UPLOAD_AML_DOCUMENTS_REQUEST,
});

const uploadAmlDocumentsSuccess = () => ({
  type: UPLOAD_AML_DOCUMENTS_SUCCESS,
});

const uploadAmlDocumentsError = e => ({
  type: UPLOAD_AML_DOCUMENTS_ERROR,
  error: true,
  payload: storableError(e),
});

const createAmlTransferRequest = () => ({
  type: CREATE_AML_TRANSFER_REQUEST,
});

const createAmlTransferSuccess = () => ({
  type: CREATE_AML_TRANSFER_SUCCESS,
});

const createAmlTransferError = e => ({
  type: CREATE_AML_TRANSFER_ERROR,
  error: true,
  payload: storableError(e),
});

const completeAmlDataLoadingRequest = () => ({
  type: COMPLETE_AML_DATA_LOADING_REQUEST,
});

const completeAmlDataLoadingSuccess = amlSeller => ({
  type: COMPLETE_AML_DATA_LOADING_SUCCESS,
  payload: amlSeller,
});

const completeAmlDataLoadingError = e => ({
  type: COMPLETE_AML_DATA_LOADING_ERROR,
  error: true,
  payload: storableError(e),
});

// ================ Thunks ================ //

export const fetchAmlSeller = () => async (dispatch, getState, sdk) => {
  dispatch(fetchAmlSellerRequest());

  try {
    const response = await requestFetchAmlSeller();
    dispatch(fetchAmlSellerSuccess(response));
  } catch (e) {
    dispatch(fetchAmlSellerError(e));
    throw e;
  }
};

export const createAmlOccasionalSeller = values => async (dispatch, getState, sdk) => {
  dispatch(createAmlOccasionalSellerRequest());

  try {
    const response = await requestCreateAmlOccasionalSeller(values);
    dispatch(createAmlOccasionalSellerSuccess(response));
  } catch (e) {
    dispatch(createAmlOccasionalSellerError(e));
    throw e;
  }
};

export const createAmlRegularSeller = values => async (dispatch, getState, sdk) => {
  dispatch(createAmlRegularSellerRequest());

  try {
    const response = await requestCreateAmlRegularSeller(values);
    dispatch(createAmlRegularSellerSuccess(response));
  } catch (e) {
    dispatch(createAmlRegularSellerError(e));
    throw e;
  }
};

export const acceptAmlTerms = values => async (dispatch, getState, sdk) => {
  dispatch(acceptAmlTermsRequest());

  try {
    const response = await requestAcceptAmlTerms(values);
    dispatch(acceptAmlTermsSuccess(response));
  } catch (e) {
    dispatch(acceptAmlTermsError(e));
    throw e;
  }
};

export const updateAmlSeller = (values, { skipDataLoading } = {}) => async (
  dispatch,
  getState,
  sdk
) => {
  if (!skipDataLoading) {
    dispatch(updateAmlSellerRequest());
  }

  try {
    const response = await requestUpdateAmlSeller(values);

    if (!skipDataLoading) {
      await dispatch(fetchCurrentUser());
      dispatch(updateAmlSellerSuccess(response));
    }
  } catch (e) {
    dispatch(updateAmlSellerError(e));
    throw e;
  }
};

export const uploadAmlDocuments = values => async (dispatch, getState, sdk) => {
  dispatch(uploadAmlDocumentsRequest());

  try {
    const response = await requestUploadAmlDocuments(values);
    dispatch(uploadAmlDocumentsSuccess(response));
  } catch (e) {
    dispatch(uploadAmlDocumentsError(e));
    throw e;
  }
};

export const createAmlTransfer = values => async (dispatch, getState, sdk) => {
  dispatch(createAmlTransferRequest());

  try {
    const response = await requestCreateAmlTransfer(values);
    dispatch(createAmlTransferSuccess(response));
  } catch (e) {
    dispatch(createAmlTransferError(e));
    throw e;
  }
};

export const completeAmlDataLoading = values => async (dispatch, getState, sdk) => {
  dispatch(completeAmlDataLoadingRequest());

  try {
    const response = await requestCompleteAmlDataLoading(values);
    await dispatch(fetchCurrentUser());
    dispatch(completeAmlDataLoadingSuccess(response));
  } catch (e) {
    dispatch(completeAmlDataLoadingError(e));
    throw e;
  }
};

export const loadData = () => async (dispatch, getState, sdk) => {
  await dispatch(fetchAmlSeller());
};
